<div class="assoc-words-page">
  <header class="project-header">
    <p class="eyebrow">Portfolio :: AssocWords</p>
    <div class="hero-layout">
      <div>
        <h1>AssocWords</h1>
        <div class="meta-badges">
          <span>Education</span>
          <span>Android</span>
          <span>Kotlin</span>
          <span>Language learning</span>
        </div>
      </div>
    </div>
  </header>

  <div class="content-grid">
    <section class="project-copy">
      <p>
        AssocWords is a community-driven language learning app that helps people remember
        vocabulary through creative, unusual, and memorable associations.
      </p>

      <ul class="feature-list">
        <li>Search for foreign words and discover mnemonic associations.</li>
        <li>Create and share your own memory hooks with other learners.</li>
        <li>Learn vocabulary across English, German, Spanish, French, and more.</li>
        <li>Rate useful associations and take part in rankings and achievements.</li>
        <li>Keep learning sessions quick and focused with a clean mobile interface.</li>
      </ul>

      <a class="project-link" target="_blank" rel="noopener"
         href="https://play.google.com/store/apps/details?id=pl.jawegiel.assocwords&hl=en">
        Download on Google Play
      </a>
    </section>

    <aside class="project-visual screenshot-gallery">
      <img class="phone-shot" src="../../../../assets/images/fragment_main_start.png" alt="Endless Blow screenshot">
      <img class="phone-shot" src="../../../../assets/images/activity_associations2.png" alt="Endless Blow screenshot">
      <img class="phone-shot" src="../../../../assets/images/activity_reminder.png" alt="Endless Blow screenshot">
      <img class="phone-shot" src="../../../../assets/images/activity_account.png" alt="Endless Blow screenshot">
      <img class="phone-shot" src="../../../../assets/images/fragment_new_association.png"
           alt="Endless Blow screenshot">
      <img class="phone-shot" src="../../../../assets/images/fragment_request_word.png" alt="Endless Blow screenshot">
      <img class="phone-shot" src="../../../../assets/images/fragment_users_requests.png" alt="Endless Blow screenshot">
      <img class="phone-shot" src="../../../../assets/images/activity_user.png" alt="Endless Blow screenshot">
    </aside>
  </div>
</div>
